import ListIcon from '@mui/icons-material/List'
import { Paper } from '@mui/material'
import { CustomTable, FormHeader } from 'components'
import { ITableHeadCellDTO } from 'data/dtos/components/i-table-head-cell-dto'
import { IInviteDTO } from 'data/dtos/operation/i-invite-dto'
import React, { useEffect, useState } from 'react'
import api from 'services/api'
import { useAlreadyMounted } from 'utils/use-already-mounted'
import { useStyles } from './styles'

const headCells: ITableHeadCellDTO[] = [
  {
    id: 'tradingName',
    label: 'Cliente',
    width: 2,
  },
  {
    id: 'invitedName',
    label: 'Nome do Convidado',
    width: 2,
  },
  {
    id: 'invitedEmail',
    label: 'Email do Convidado',
    width: 2,
  },
  {
    id: 'inviteSentDate',
    label: 'Enviado',
    width: 1,
  },
  {
    id: 'accountCreationDate',
    label: 'Criação Conta',
    width: 1,
  },
  {
    id: 'firstAccessDate',
    label: 'Primeiro Acesso',
    width: 1,
  },
  {
    id: 'certificateUploadDate',
    label: 'Certificado',
    width: 1,
  },
]

const InviteList: React.FC = () => {
  const [loading, setLoading] = useState(0)
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(100)
  const [orderByDirection, setOrderByDirection] = useState(true)
  const [rowsCount, setRowsCount] = useState(0)
  const [invitesList, setInvitesList] = useState<IInviteDTO[]>([])
  const [recordToDelete, setRecordToDelete] = useState<string | null>('')
  const [columnOrder, setColumnOrder] = useState<('ASC' | 'DESC')[]>([])

  const classes = useStyles()
  const alreadyMounted = useAlreadyMounted()

  const loadInvites = async () => {
    setLoading(1)

    await api
      .post('/invites/list', { search, page, rowsPerPage, columnOrder })
      .then(async (listResponse) => {
        const { data } = listResponse.data
        setInvitesList(data)

        await api
          .post('/invites/count', { search })
          .then((countResponse) => {
            const { count } = countResponse.data.data
            setRowsCount(count)
          })
          .then(() => setLoading(0))
          .catch((error) => {
            console.log(error)
          })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleDelete = async () => {
    await api
      .delete(`/invites/${recordToDelete}`)
      .then(async () => {
        await loadInvites()
      })
      .catch((error) => {
        console.log(error.response?.data)
      })
  }

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = async (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!alreadyMounted) {
        loadInvites()
      }
    }, 1000)

    return () => clearTimeout(timeout)
  }, [search])

  useEffect(() => {
    loadInvites()
  }, [orderByDirection, rowsPerPage, page])

  return (
    <Paper
      elevation={0}
      className={classes.paper}
    >
      <FormHeader
        title='Convites Enviados'
        icon={ListIcon}
        newRoute='/invites/new'
        helpText='Dados coletados sobre os convites de acesso á plataforma.'
      />

      <CustomTable
        headCells={headCells}
        rows={invitesList}
        totalRows={rowsCount}
        handleSearch={setSearch}
        isLoading={loading}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        page={page}
        editRoute='/invites/edit'
        handleDelete={handleDelete}
        handleRecordToDelete={setRecordToDelete}
        columnOrder={columnOrder}
        setColumnOrder={setColumnOrder}
        orderByDirection={orderByDirection}
        setOrderByDirection={setOrderByDirection}
      />
    </Paper>
  )
}

export default InviteList
